import { useCallback } from 'react'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { useAllTreeGroups } from '../tree-import/components/cets/AllTreeGroupsProvider'
import { useGroupLimitsCall } from '../tree-import/services/getTreeLimitsCall'

/**
 * Shared hook for upload GEDCOM button functionality.
 * Manages upload button state (disabled/enabled based on tree limits) and handles
 * data refetching after a GEDCOM file has been successfully uploaded.
 * Used by both UploadGedcomCard and ManageTreeGroup components.
 * @returns {object} Upload button state and refetch callback
 */
export function useUploadTree() {
  const { groups, getAndSetGroups } = useGroupsContext()
  const { refetchFiles } = useAllTreeGroups()
  const [{ data, loading: loadingGroupLimits }] = useGroupLimitsCall()

  const maxTrees = data?.maxTreesPerUser || 10
  const isLoadingLimits = loadingGroupLimits || !groups
  const disableCreateTreeButton = isLoadingLimits || !(maxTrees && groups.length < maxTrees)

  const refetchData = useCallback(() => {
    const ignoreCache = true
    getAndSetGroups(ignoreCache)
    refetchFiles()
  }, [getAndSetGroups, refetchFiles])

  return {
    maxTrees,
    isLoadingLimits,
    disableCreateTreeButton,
    refetchData,
  }
}
